module.exports = __webpack_public_path__ + "static/worker-apply-online-342df25a6b7967393eaf2ba857162e18.png";